import React from 'react'
import './Orders.css'
function Orders() {
    return (
        <div className="orders">
            <h1>Your Orders</h1>
        </div>
    )
}

export default Orders
